import { assign } from 'lodash'
import type { Component, WidgetRefDataItem } from '@wix/thunderbolt-becky-types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import type { VariablesCssData } from './variables.types'
import { getVariant } from '../../utils/toBreakpointVariantsMap'
import type { FeatureRefs } from '../cssFeatures.types'
import { getRefCompIdFromInflatedId, isInflatedId, getVariableCss } from '@wix/thunderbolt-commons'

export const variables = createCssCompNode('variables', 'variables', {
	getDependencies: (component: Component, refs: FeatureRefs<'variables'>) => {
		return {
			variablesList: component.variablesQuery ? refs.variablesQuery(component.variablesQuery) : null,
			rootRefComponentData:
				component?.id && isInflatedId(component.id)
					? refs.dataQuery(`dataItem-${getRefCompIdFromInflatedId(component.id)}`)
					: null,
			environmentRefs: { renderSticky: envRefs.renderSticky },
			experiments: envRefs.experiments,
		}
	},
	toViewItem: (component, { rootRefComponentData, variablesList, environmentRefs, experiments }): VariablesCssData | null => {
		if (!variablesList || !variablesList.variables) {
			return null
		}
		const isNewStyleApi = !!experiments['specs.thunderbolt.newStyleApi']

		return variablesList.variables.reduce<VariablesCssData>(
			(acc, { id: varId, name: varName, value: refArray }) => {
				refArray.values.forEach((val) => {
					const { breakpointId, variantsKey, value } = getVariant(val)
					acc[breakpointId] = acc[breakpointId] || {}
					acc[breakpointId][variantsKey] = acc[breakpointId][variantsKey] || {}
					assign(
						acc[breakpointId][variantsKey],
						getVariableCss(
							value,
							(rootRefComponentData as WidgetRefDataItem)?.isBuilderComponent ? varName ?? varId : varId,
							environmentRefs,
							isNewStyleApi
						)
					)
				})

				return acc
			},
			{}
		)
	},
})
